import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/utils/cn';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  containerClassName?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, containerClassName, label, error, helperText, id, ...props }, ref) => {
    const inputId = id ?? props.name;

    return (
      <div className={cn('flex flex-col gap-2', containerClassName)}>
        {label && (
          <label htmlFor={inputId} className="text-xs font-bold uppercase tracking-wider text-text-secondary">
            {label}
            {props.required && <span className="ml-1 text-state-error">*</span>}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          className={cn(
            'focus-ring h-11 w-full rounded-md border bg-bg-surface px-4 text-sm text-text-primary placeholder:text-text-tertiary disabled:cursor-not-allowed disabled:opacity-50',
            error ? 'border-state-error' : 'border-border focus:border-brand-primary',
            className,
          )}
          aria-invalid={Boolean(error)}
          {...props}
        />
        {error ? (
          <p className="text-xs text-state-error">{error}</p>
        ) : helperText ? (
          <p className="text-xs text-text-tertiary">{helperText}</p>
        ) : null}
      </div>
    );
  },
);
Input.displayName = 'Input';
